import type { QueryClient } from '@tanstack/react-query'
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { SearchX } from 'lucide-react'

import { AvisoAtualizacao } from '@/components/pwa/aviso-atualizacao'
import { EstadoVazio } from '@/components/ui/estado'
import { Toasts } from '@/components/ui/toast'
import { buttonVariants } from '@/components/ui/button'
import type { TrpcClient } from '@/lib/trpc'

export interface ContextoRouter {
  queryClient: QueryClient
  trpcClient: TrpcClient
}

export const Route = createRootRouteWithContext<ContextoRouter>()({
  component: () => (
    <>
      <Outlet />
      <Toasts />
      <AvisoAtualizacao />
    </>
  ),
  notFoundComponent: () => (
    <main className="grid min-h-full place-items-center p-8">
      <EstadoVazio
        Icone={SearchX}
        titulo="Página não encontrada"
        texto="O endereço não existe ou mudou de lugar."
        tamanho="lg"
        acao={
          <Link to="/" className={buttonVariants({ variant: 'secondary', size: 'md' })}>
            Ir para o início
          </Link>
        }
      />
    </main>
  ),
})
